import { module } from 'angular';
import qrCodeScannerComponent from './qr-code-scanner.component';
import buttonQrCodeScanner from './button-qr-code-scanner/button-qr-code-scanner.component';

export default module('app')
	.component('qrCodeScanner', qrCodeScannerComponent)
	.component('buttonQrCodeScanner', buttonQrCodeScanner)
	.name;
